document.addEventListener('DOMContentLoaded', () => {

  const circles = document.querySelectorAll('.progress-fill');

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (!entry.isIntersecting) return;

      const circle = entry.target;

      if (circle.dataset.animated) return;

      circle.dataset.animated = true;

      const target = parseInt(circle.dataset.target);

      const radius = 54;
      const circumference = 2 * Math.PI * radius;

      const offset =
        circumference -
        (target / 100) * circumference;

      circle.style.strokeDasharray = circumference;
      circle.style.strokeDashoffset = offset;

      const number =
        circle.closest('.progress-circle')
              .querySelector('.progress-number');

      let current = 0;

      const timer = setInterval(() => {

        current++;

        number.textContent = current + '%';

        if(current >= target){
          clearInterval(timer);
        }

      }, 20);

    });

  }, { threshold: 0.4 });

  circles.forEach(circle => {
    observer.observe(circle);
  });

});

document.querySelectorAll('.great-gallery').forEach(slider => {

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', e => {

    isDown = true;

    startX = e.pageX - slider.offsetLeft;

    scrollLeft = slider.scrollLeft;

  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
  });

  slider.addEventListener('mousemove', e => {

    if(!isDown) return;

    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;

    const walk = (x - startX) * 2;

    slider.scrollLeft = scrollLeft - walk;

  });

});

document.addEventListener('DOMContentLoaded', () => {

  const config = document.querySelector('.dynamic-sales-config');
  const countElement = document.querySelector('.dynamic-sales-count');
  const stockElement = document.querySelector('.dynamic-stock-left');

  if (!config || !countElement) return;

  const productId = config.dataset.productId;

  const min = parseInt(config.dataset.min);
  const max = parseInt(config.dataset.max);

  const initialStock = parseInt(config.dataset.stock);

  const salesKey = `sales_count_${productId}`;
  const stockKey = `stock_left_${productId}`;

  let sales = parseInt(localStorage.getItem(salesKey));
  let stock = parseInt(localStorage.getItem(stockKey));

  if (isNaN(sales)) {

    sales =
      Math.floor(Math.random() * (max - min + 1)) + min;

  }

  if (isNaN(stock)) {

    stock = initialStock;

  }

  if (!isNaN(localStorage.getItem(salesKey))) {

    if (Math.random() < 0.20) {

      sales += 1;

      if (stock > 1) {
        stock -= 1;
      }

    }

  }

  localStorage.setItem(salesKey, sales);
  localStorage.setItem(stockKey, stock);

  animateNumber(countElement, sales);

  if (stockElement) {
    animateNumber(stockElement, stock);
  }

});

function animateNumber(element, target) {

  let current = 0;

  const duration = 1500;

  const increment =
    Math.max(1, Math.ceil(target / (duration / 16)));

  function update() {

    current += increment;

    if (current >= target) {

      element.textContent = target;

      return;

    }

    element.textContent = current;

    requestAnimationFrame(update);
  }

  update();
}